import $ from 'jquery';
import EventsHelper from '../../../_helpers/events';

export default class MatchStatsByPlayer {

  $statsContainer = null;
  $teamsBtn = null;
  $setsBtn = null;
  $statisticsBtn = null;
  $statisticBlocks = null;
  $statisticTooltips = null;

  selectedTeam = 'teama';
  selectedSet = 'all';
  selectedStat = 'scoring';
 
  constructor() {
    let _this = this;

    _this.init();

    EventsHelper.OnAjaxModuleLoaded(function () {
      setTimeout(function () {
        _this.init();
      }, 2000);
      
    });

    EventsHelper.On('PlayerStatsDataUpdate', function (data) {
      setTimeout(function () {
        _this.init();
      }, 2000);
    });

    EventsHelper.On('TabChanged', function (tabid) {
      if (tabid.detail === 'boxscore') {
        _this.init();
        EventsHelper.Trigger('DropDownReload');
      }
    });

  }

  init() {

    let _this = this;

    _this.$statsContainer = $('.vbw-match-stats-player-container');
    _this.$teamsBtn = $('.vbw-match-stats-player-container').find('.team-tabs li');
    _this.$setsBtn = $('.vbw-match-stats-player-container').find('.sets-dropdown li');
    _this.$statisticsBtn = $('.vbw-match-stats-player-container').find('.stats-tabs li');
    _this.$statisticBlocks = $('.vbw-match-stats-player-container').find('.vbw-match-player-statistic-table');
    _this.$statisticTooltips = $('.vbw-match-stats-player-container').find('.vbw-tooltip-wrapper');

    _this.handleEvents();

    EventsHelper.Trigger('DropDownReload');
  }

  handleEvents() {
    let _this = this;

    _this.$teamsBtn.click(function (e) {
      e.preventDefault();

      let tab = $(this);
      let team = tab.data('tab-id');

      tab.siblings().removeClass('active');
      tab.addClass('active');

      _this.selectedTeam = team;
      _this.applyFilters();
    });


    _this.$setsBtn.click(function () {

      let tab = $(this);
      let set = tab.data('tab-id');

      tab.siblings().removeClass('active');
      tab.addClass('active');

      _this.selectedSet = set;
      _this.applyFilters();
    });

    _this.$statisticsBtn.click(function () {

      let tab = $(this);
      let stat = tab.data('tab-id');

      tab.siblings().removeClass('active');
      tab.addClass('active');

      _this.selectedStat = stat;
      _this.applyFilters();
    });

  }

  applyFilters() {

    let _this = this;

    let filterSelector = _this.getFilterSelector();

    _this.$statisticBlocks.addClass('hidden');
    _this.$statisticTooltips.addClass('hidden');
    let $selectedBlock = _this.$statisticBlocks.filter(filterSelector);

    $selectedBlock.filter(filterSelector).removeClass('hidden');
    $selectedBlock.prev('.vbw-tooltip-wrapper').removeClass('hidden');

  }

  getFilterSelector() {
    let _this = this;

    let selector = '';

    if (_this.selectedTeam) { selector += ['[data-team="', _this.selectedTeam, '"]'].join(''); }
    if (_this.selectedSet) { selector += ['[data-set="', _this.selectedSet, '"]'].join(''); }
    if (_this.selectedStat) { selector += ['[data-stattype="', _this.selectedStat, '"]'].join(''); }

    return selector;
  }

}


